module.exports = "/assets/data/5159131c3cf55a4788d42a88639bccd7-SS3.data.json";